import { useNavigate } from "react-router-dom"

import { Button } from '@mui/material'

const Menu = () => {

  const navigate = useNavigate()

  return (
    <div className='flex flex-row justify-end whitespace-nowrap'>
      <Button onClick={() => navigate("/billing/plan")} variant='text' sx={{color:"text.secondary"}}>Subscription Plan</Button>
    </div>
  )
}

export default Menu